import {
  Link,
  useLoaderData,
} from "react-router-dom";
import * as API from "../services/entmotivacional";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getEntmotivacionalByID(params.entmotivacionalId);
}


export function EntmotivacionalItem(props) {
  const entmotivacional = useLoaderData();
  const errorMessage = entmotivacional.message;
  console.log(entmotivacional);

  const entmotivResp = entmotivacional.meta?.entmotivResp;
  const entmotivFecha = entmotivacional.meta?.metaFecha;
  const entmotivObs = entmotivacional.meta?.entmotivObs;

  const entmotivDate = new Date(entmotivacional.date);
  const diffDate = (Math.abs(new Date() - entmotivDate) / 36e5);

  return (
    <>
    <div id="content">
      {entmotivacional.length === 0 ? (
        <div>Cargando...</div>
      ) : (
      errorMessage? (
        <p>{errorMessage}</p>
      ) : (
      <form id="formUpdatelement">
        <fieldset id="disabledContainer" disabled="disabled">
        <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='entmotivResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='entmotivResp'
                  required
                  type='text'
                  readOnly
                  value={entmotivResp}

                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='entmotivFecha'>Fecha entrevista</label>
              <div className='control'>
                <input
                  className='input'
                  id='entmotivFecha'
                  required
                  type='date'
                  readOnly
                  value={entmotivFecha}

                />
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='entmotivObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='entmotivObs'
                id='entmotivObs'
                readOnly
                value={entmotivObs}

              ></textarea>
            </div>
          </div>

      </fieldset>
      </form>
      ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      }
      </div>
      }
    </>
  );
}